import {createProjectModel} from 'company-management/utils/project-model'
import {accounts, create, update} from '../services/account'

const model = createProjectModel({
    projectNamespace: 'account',

    state: {
        tableData: {},
    },

    effects: {
        *accounts(_, {call, put, select}) {
            const {tableData} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }
            const res = yield call(accounts, newParams)
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = res?.pagination?.rows_found ?? 0
                },
            })
            return res
        },
        *create({payload}, {call}) {
            return yield call(create, payload)
        },
        *update({payload}, {call}) {
            return yield call(update, payload)
        },
    },

    reducers: {},
})

export default model
